import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { SearchProvider } from '@sajari/react-hooks';
import { getSearchParams, ThemeProvider, createContext } from '@sajari/react-sdk-utils';
import { useState, useEffect } from 'react';
import { LiveAnnouncer } from 'react-aria-live';
import { I18nextProvider } from 'react-i18next';
import i18n from '../i18n/index.esm.js';
import { isViewType } from '../utils/queryParams.esm.js';
import { jsx } from '@emotion/core/jsx-runtime';

var _createContext = /*#__PURE__*/createContext({
  strict: true,
  name: 'PipelineContext'
}),
    Provider = _createContext[0],
    useSearchUIContext = _createContext[1];

var ContextProvider = function ContextProvider(_ref) {
  var children = _ref.children,
      search = _ref.search,
      autocomplete = _ref.autocomplete,
      defaultFilter = _ref.defaultFilter,
      searchOnLoad = _ref.searchOnLoad,
      initialResponse = _ref.initialResponse,
      _ref$ratingMax = _ref.ratingMax,
      ratingMax = _ref$ratingMax === void 0 ? 5 : _ref$ratingMax,
      _ref$currency = _ref.currency,
      currency = _ref$currency === void 0 ? 'USD' : _ref$currency,
      theme = _ref.theme,
      importantStyles = _ref.importantStyles,
      _ref$disableDefaultSt = _ref.disableDefaultStyles,
      disableDefaultStyles = _ref$disableDefaultSt === void 0 ? false : _ref$disableDefaultSt,
      _ref$customClassNames = _ref.customClassNames,
      customClassNames = _ref$customClassNames === void 0 ? {} : _ref$customClassNames,
      _ref$viewType = _ref.viewType,
      defaultViewType = _ref$viewType === void 0 ? 'grid' : _ref$viewType,
      _ref$downshiftEnviron = _ref.downshiftEnvironment,
      downshiftEnvironment = _ref$downshiftEnviron === void 0 ? null : _ref$downshiftEnviron,
      syncURLState = _ref.syncURLState;
  var params = getSearchParams();

  var _useState = useState(i18n.language),
      language = _useState[0],
      setLanguage = _useState[1];

  var _useState2 = useState(isViewType(params.viewType) && syncURLState ? params.viewType : defaultViewType),
      viewType = _useState2[0],
      setViewType = _useState2[1];

  useEffect(function () {
    var event = 'languageChanged';
    i18n.on(event, setLanguage);
    return function () {
      i18n.off(event);
    };
  }, []);
  return jsx(Provider, {
    value: {
      tracking: search.pipeline.getTracking(),
      disableDefaultStyles: disableDefaultStyles,
      currency: currency,
      customClassNames: customClassNames,
      language: language,
      ratingMax: ratingMax,
      viewType: viewType,
      setViewType: setViewType,
      downshiftEnvironment: downshiftEnvironment
    },
    children: jsx(SearchProvider, {
      search: search,
      autocomplete: autocomplete,
      defaultFilter: defaultFilter,
      searchOnLoad: searchOnLoad,
      initialResponse: initialResponse,
      syncURLState: typeof syncURLState !== 'boolean' && typeof syncURLState !== 'undefined' ? _extends({}, syncURLState, {
        extendedParams: [].concat((syncURLState == null ? void 0 : syncURLState.extendedParams) || [], [{
          key: 'viewType',
          defaultValue: defaultViewType,
          callback: function callback(value) {
            setViewType(isViewType(value) ? value : defaultViewType);
          },
          value: viewType
        }])
      }) : syncURLState,
      children: jsx(LiveAnnouncer, {
        children: jsx(I18nextProvider, {
          i18n: i18n,
          children: jsx(ThemeProvider, {
            theme: theme,
            importantStyles: importantStyles,
            children: children
          })
        })
      })
    })
  });
};

export default ContextProvider;
export { useSearchUIContext };
//# sourceMappingURL=index.esm.js.map
